import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';
import ChatStatusMessage from './ChatStatusMessage';
import ChatWelcomeMessage from './ChatWelcomeMessage';
import { ScrollArea } from "@/components/ui/scroll-area";
import TalentCardCarousel from './TalentCardCarousel';

const ChatMessageList = ({ messages, loading, error, contentClassName = '', innerClassName = '', onSendMessage }) => {
  console.log('ChatMessageList saa viestit:', messages);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  // Jos yksikään status- TAI delta-viesti on {status: 'finished_successfully'}, älä näytä mitään status-viestiä
  const hasFinishedStatus = messages.some(
    (msg) =>
      ((msg.type === 'status' || msg.type === 'delta') &&
        typeof msg.content === 'object' &&
        msg.content.status === 'finished_successfully')
  );

  // Näytä viimeisin status-viesti vain jos ei finished
  const lastStatus = !hasFinishedStatus
    ? (() => {
        for (let i = messages.length - 1; i >= 0; i--) {
          if (messages[i].type === 'status') return messages[i];
        }
        return null;
      })()
    : null;

  // Suodata pois structured output -viestit (talentIds + justification), myös jos content on string
  const nonStatusMessages = messages.filter((msg) => {
    if (msg.role === 'assistant') {
      // Jos content on objekti
      if (
        typeof msg.content === 'object' &&
        msg.content &&
        Array.isArray(msg.content.talentIds) &&
        typeof msg.content.justification === 'string'
      ) {
        return false;
      }
      // Jos content on string, yritä parsia JSONiksi
      if (typeof msg.content === 'string') {
        try {
          const parsed = JSON.parse(msg.content);
          if (
            parsed &&
            Array.isArray(parsed.talentIds) &&
            typeof parsed.justification === 'string'
          ) {
            return false;
          }
        } catch (e) {
          // Ei ollut JSON, ei suodateta
        }
      }
    }
    return msg.type !== 'status';
  });

  // Show welcome message if there are no messages
  const showWelcome = nonStatusMessages.length === 0 && !loading && !lastStatus;

  return (
    <ScrollArea className={`h-full bg-background flex-1 overflow-y-auto max-h-full ${contentClassName}`}>
      <div ref={scrollRef} className={innerClassName}>
        {showWelcome && (
          <ChatWelcomeMessage onStartChat={onSendMessage} />
        )}
        {nonStatusMessages.map((message, index) => {
          // Jos viesti on component-tyyppinen ja sisältää talentit, renderöi karuselli
          if (message.type === 'component' && message.content?.type === 'talents') {
            return <TalentCardCarousel key={index} talents={message.content.talents} />;
          }

          // UUSI: Jos viesti on tool_call-tyyppinen ja talentSearchAgent, renderöi karuselli resultista
          if (
            message.type === 'tool_call' &&
            message.content?.name === 'talentSearchAgent' &&
            message.content?.result
          ) {
            let parsedResult = null;
            try {
              parsedResult = typeof message.content.result === 'string'
                ? JSON.parse(message.content.result)
                : message.content.result;
            } catch (e) {
              parsedResult = null;
            }
            if (
              parsedResult &&
              Array.isArray(parsedResult.talents) &&
              parsedResult.talents.length > 0
            ) {
              return <TalentCardCarousel key={index} talents={parsedResult.talents} />;
            }
          }
          // Oletus: delta ja muut viestit
          return <ChatMessage key={index} message={message} />;
        })}
        {lastStatus && (
          <ChatStatusMessage content={lastStatus.content} active={true} />
        )}
        {error && (
          <div className="flex items-center justify-center p-4 text-destructive">
            <div>{typeof error === 'string' ? error : (error?.message || JSON.stringify(error))}</div>
          </div>
        )}
      </div>
    </ScrollArea>
  );
};

export default ChatMessageList; 